import withErrorBoundary from '@app/components/presentational/common/ErrorBoundary/ErrorBoundary';
import SpaceWidgetSection from './SpaceWidgetSection';

export default withErrorBoundary(SpaceWidgetSection, {
  message: 'Unable to load the spaces widget.',
});
